import projects from 'reducers/projects';
import products from 'reducers/products';
import user from 'reducers/user';
import publicProjects from 'reducers/projects/public';
import online from 'reducers/online';
import currentProjectIDReducer from 'reducers/currentProjectIDReducer';
import currentProject from 'reducers/currentProject';

export default function rootReducer(state={}, action) {
  return {
    currentProjectID: currentProjectIDReducer(state.currentProjectID, action),
    projects: projects(state.projects, action),
    products: products(state.products, action),
    publicProjects: publicProjects(state.publicProjects, action),
    user: user(state.user, action),
    online: online(state.online, action),
  };
}

export function rootReducerWithCurrentProjectWrapper(state, action) {
  return currentProject(rootReducer(state, action), action);
}
